import { createEvent } from 'react-event-hook';

export const { useMainFilterResetListener, emitMainFilterReset } =
    createEvent('main-filter-reset')();
